import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { FilterService } from 'src/app/services/filter.service';
import { DateRangeFilterModel } from '../../models/date-range-filter-model';

@Component({
  selector: 'ness-date-range-filter-status',
  templateUrl: './date-range-filter-status.component.html',
  styles: [':host-context(.d-flex.flex-wrap) { display: flex !important; flex-wrap: wrap !important;}'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateRangeFilterStatusComponent {
  dateRangeFilterModel$: Observable<DateRangeFilterModel> = this.filterService.dateRangeFilterModel;

  constructor(private filterService: FilterService) { }
}
